/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usage_Pricing_NoteInputs */

const en_usage_pricing_note = /** @type {(inputs: Usage_Pricing_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estimates exclude storage costs`)
};

const fr_usage_pricing_note = /** @type {(inputs: Usage_Pricing_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les estimations excluent les frais de stockage`)
};

const de_usage_pricing_note = /** @type {(inputs: Usage_Pricing_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Schätzungen schließen Lagerkosten aus.`)
};

const it_usage_pricing_note = /** @type {(inputs: Usage_Pricing_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le stime escludono i costi di stoccaggio`)
};

const ru_usage_pricing_note = /** @type {(inputs: Usage_Pricing_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`В смету не включены расходы на хранение.`)
};

const es_usage_pricing_note = /** @type {(inputs: Usage_Pricing_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las estimaciones excluyen los costes de almacenamiento`)
};

const zh_cn2_usage_pricing_note = /** @type {(inputs: Usage_Pricing_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`估算不包括仓储成本`)
};

const ja_usage_pricing_note = /** @type {(inputs: Usage_Pricing_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`推定には保管費用は含まれません`)
};

const hi_usage_pricing_note = /** @type {(inputs: Usage_Pricing_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अनुमानों में भंडारण लागत शामिल नहीं है।`)
};

const pt_pt2_usage_pricing_note = /** @type {(inputs: Usage_Pricing_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As estimativas não incluem custos de armazenamento.`)
};

/**
* | output |
* | --- |
* | "Estimates exclude storage costs" |
*
* @param {Usage_Pricing_NoteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const usage_pricing_note = /** @type {((inputs?: Usage_Pricing_NoteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_Pricing_NoteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_usage_pricing_note(inputs)
	if (locale === "de") return de_usage_pricing_note(inputs)
	if (locale === "it") return it_usage_pricing_note(inputs)
	if (locale === "ru") return ru_usage_pricing_note(inputs)
	if (locale === "es") return es_usage_pricing_note(inputs)
	if (locale === "zh-CN") return zh_cn2_usage_pricing_note(inputs)
	if (locale === "ja") return ja_usage_pricing_note(inputs)
	if (locale === "hi") return hi_usage_pricing_note(inputs)
	if (locale === "pt-PT") return pt_pt2_usage_pricing_note(inputs)
	return en_usage_pricing_note(inputs)
});